const RuleRouteName = {
  RULE: 'rule',
  RULE_CONFIG: 'ruleConfig',
  RULE_COPY: 'ruleCopy',
  RULE_TICKET: 'ruleTicket',
};

export default RuleRouteName;
